// extracted by mini-css-extract-plugin
module.exports = {"defaultButtonColor":"var(--secondary-color)","defaultButtonColorDisabled":"var(--secondary-color-lightest)","titleSpacing":"var(--anx-title-spacing)"};